import Vue from 'vue'
import Vuex from 'vuex'
import createLogger from 'vuex/dist/logger'
import { plugins, debug } from '../../store_mixins/common'

Vue.use(Vuex)

const state = () => {
  return {}
}

const getters = {}

const mutations = {}

const actions = {}

export default new Vuex.Store({
  state,
  getters,
  mutations,
  actions,
  plugins: debug ? [...plugins, createLogger()] : plugins,
  strict: debug,
})
